import { isFunction } from '@dxb-web-ui-framework/common/utils/Helper';
import { AuthClient } from '../context/types';

export const isKeycloakAuthenticated = (authClient: AuthClient) => !!authClient.idToken && !!authClient.token;

export const hasKeycloakAttachedListeners = (authClient: AuthClient) => {
  const { onReady, onAuthError, onAuthSuccess, onTokenExpired, onAuthRefreshError, onAuthRefreshSuccess } = authClient;
  return (
    isFunction(onReady) &&
    isFunction(onAuthError) &&
    isFunction(onAuthSuccess) &&
    isFunction(onTokenExpired) &&
    isFunction(onAuthRefreshError) &&
    isFunction(onAuthRefreshSuccess)
  );
};
